// 搜索结果点击下载下方弹出推荐应用
import React, { memo, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Rate from '../Rate/Rate';
import Button from '../Button/Button';
import AButton from '../AButton/AButton';
import styles from './SoftCardPRank.module.less';
import rank1 from '../../static/rank1.png';
import rank2 from '../../static/rank2.png';
import rank3 from '../../static/rank3.png';
import rank4 from '../../static/rank4.png';
import rank5 from '../../static/rank5.png';
import { hasClass, removeClass, addClass } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo, index }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const optRef = useRef(null);

  const rankCup = {
    '1': rank1,
    '2': rank2,
    '3': rank3,
    '4': rank4,
    '5': rank5,
  };

  const handleSoftCard = useCallback(() => {
    // 小banner点击
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          cardName: 'SoftCardPRank',
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfo.source || 'SoftCardPRank_Source_Err',
        source_pp: logInfoData.source_p,
      }),
    );

    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  }, [dispatch, logInfo, history]);

  const onMouseOver = useCallback(
    e => {
      if (optRef && optRef.current) {
        const optDom = optRef.current;
        addClass(optDom, styles.mouse_in);
      }
    },
    [optRef],
  );

  const onMouseLeave = useCallback(e => {
    if (optRef && optRef.current) {
      const optDom = optRef.current;
      addClass(optDom, styles.mouse_out);
    }
  }, []);

  const onAnimationEnd = useCallback(e => {
    if (optRef && optRef.current) {
      const optDom = optRef.current;
      if (hasClass(optDom, styles.mouse_out)) {
        removeClass(optDom, styles.mouse_in);
        removeClass(optDom, styles.mouse_out);
      }
    }
  }, []);

  return (
    <div
      className={styles.soft_card}
      onMouseOver={e => onMouseOver(e)}
      onMouseLeave={e => onMouseLeave(e)}
      onAnimationEnd={e => onAnimationEnd(e)}
      onClick={() => {
        handleSoftCard(soft);
      }}
    >
      <img className={styles.soft_card_index} src={rankCup[index] || ''} />
      <div className={styles.soft_card_img_box}>
        <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
        {soft.androidType === '1' && <div className={styles.soft_card_logo} />}
      </div>
      <div className={styles.soft_card_infos}>
        <div
          className={styles.soft_card_title}
          dangerouslySetInnerHTML={{ __html: soft.softName }}
          title={soft.softName.length > 8 ? soft.softName : ''}
        />
        <div className={styles.soft_card_score}>
          <Rate
            score={(Number(soft.score) / 20).toFixed(1)}
            rateInfo={{ className: styles.soft_score }}
          />
        </div>
        <div className={styles.soft_card_num}>
          {soft.appDesc || `${soft.downloadCount || '0次'}安装`}
        </div>
        <div
          className={styles.soft_card_opt}
          ref={optRef}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {soft.androidType === '1' ? (
            <AButton
              soft={soft}
              info={{
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.soft_button_open,
                text: '安装',
              }}
              // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
              logInfo={{ ...logInfo }}
            />
          ) : (
            <Button
              soft={soft}
              info={{
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.soft_button_open,
                text: '安装',
              }}
              // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
              logInfo={{ ...logInfo }}
            />
          )}
        </div>
      </div>
    </div>
  );
});
